module.exports = "/assets/419211d22926ad04ed997b0ac89bbd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MP.png
// module id = 1622
// module chunks = 0